import React from 'react';
import DropdownLap from './dropdownLap';


export default class navBarLap extends React.Component {
  

  render() {
    return (
      <nav>
      <span className="navBar" style={{textAlign:"center"}}>
          <div><h1 style={{ textAlign: "left"}}>Mitton Benjamin</h1></div>
          <div style={{position:'absolute',top:"4%",left:"90%"}}><DropdownLap /></div>
         </span>
        <div className="lignes">
          <div className="l1"></div>
          <div className="l2"></div>
        </div>
      </nav>
    );
  }

}